



















import QrcodeVue from "qrcode.vue";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component({
  name: "buyCourseComfirmPreviewDialog",
  components: {
    QrcodeVue,
  },
})
export default class extends Vue {
  @Prop() counterUrl!: number;
  qrcodeSrc: string = "";
  created() {
    if (!this.counterUrl) {
      return false;
    }
    this.qrcodeSrc = `${this.counterUrl}`;
  }
}
